export default __webpack_public_path__ + "img/submenu-arrow-right.f490464f.svg";